import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  accountCard: {
    padding: theme.spacing(8)
  }
});

export default makeStyles(styles);
